import React, { useState, useEffect } from 'react';

const FeedbackButton = () => {
  const [open, setOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [email, setEmail] = useState('');
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showWhatsApp, setShowWhatsApp] = useState(null);
  const isEnglish = window.location.pathname.includes('/en/');
  const isArPage = window.location.pathname.includes('/ar/');
  const isMainPage = window.location.pathname === '/' || window.location.pathname === '';
  const isWhatsAppPage = isMainPage || isArPage;

  const language = isEnglish ? 'en' : 'ar';
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const whatsappNumber = '447459547166';
  const whatsappMessage = encodeURIComponent('مرحباً، أريد مشاركة رأيي أو اقتراح تحسين حاسبة.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const t = {
    btn: isEnglish ? 'Feedback' : 'خبرنا رأيك',
    title: isEnglish ? 'Tell us what you think' : 'شاركنا رأيك - هل تريد منا إضافة أو تحسين أي حاسبة ؟',
    ph: isEnglish ? 'What should we improve or add?' : 'ما الذي يجب تحسينه أو إضافته؟',
    email: isEnglish ? 'Email (optional)' : 'البريد الإلكتروني (اختياري)',
    send: isEnglish ? 'Send Feedback' : 'إرسال الملاحظات',
    cancel: isEnglish ? 'Cancel' : 'إلغاء',
    rate: isEnglish ? 'Rate your experience 😊:' : 'قيّم تجربتك 😊:',
    load: isEnglish ? 'Loading...' : 'جاري التحميل...',
    sending: isEnglish ? 'Sending...' : 'جاري الإرسال...'
  };

  // ── Fetch WhatsApp flag from Firestore ──
  useEffect(() => {
    if (!isWhatsAppPage) {
      setShowWhatsApp(false);
      return;
    }

    const fetchFlag = async () => {
      try {
        const { db } = await import('../firebaseConfig');
        const { collection, getDocs } = await import('firebase/firestore');
        const snap = await getDocs(collection(db, 'whatsappButton'));
        const docData = snap.docs[0]?.data();
        setShowWhatsApp(docData?.enabled !== false); // true unless explicitly false
      } catch {
        setShowWhatsApp(true); // default to show on error
      }
    };

    fetchFlag();
  }, [isWhatsAppPage]);


  const handleOpen = () => {
    setButtonLoading(true);
    setTimeout(() => { setOpen(true); setButtonLoading(false); }, 100);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { db } = await import('../firebaseConfig');
      const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
      await addDoc(collection(db, window.location.hostname === 'localhost' ? 'calculatorFeedbackDev' : 'calculatorFeedback'), {
        text: feedbackText,
        email: email.trim() || null,
        rating,
        timestamp: serverTimestamp(),
        language,
        page: window.location.pathname,
        deviceType: isMobile ? 'mobile' : 'desktop',
      });
      setOpen(false); setFeedbackText(''); setEmail(''); setRating(0);
      localStorage.setItem('feedbackSubmitted', 'true');
      alert(isEnglish ? 'Thank you for your feedback!' : 'شكراً لملاحظاتك!');
    } catch (e) {
      console.error('Error submitting feedback:', e);
    } finally {
      setLoading(false);
    }
  };

  const dir = isEnglish ? 'ltr' : 'rtl';
  const inp = { width: '100%', padding: '7px 10px', border: '2px solid #e2e8f0', borderRadius: 8, fontSize: 18, marginBottom: 8, boxSizing: 'border-box', fontFamily: 'inherit' };

  // ── WhatsApp button (main page or /ar/ pages) ──
  if (isWhatsAppPage) {
    if (showWhatsApp === null) return null;
    if (!showWhatsApp) return null;
    return (
      <div style={{ position: 'fixed', bottom: 115, left: 10, zIndex: 1300 }}>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#25D366',
            border: 0,
            borderRadius: '50%',
            width: 52,
            height: 52,
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 32 32" fill="#fff">
            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.737 5.469 2.027 7.774L0 32l8.437-2.01A15.938 15.938 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.747-1.84l-.484-.287-5.01 1.194 1.23-4.876-.317-.502A13.267 13.267 0 012.667 16C2.667 8.637 8.637 2.667 16 2.667S29.333 8.637 29.333 16 23.363 29.333 16 29.333zm7.27-9.862c-.398-.199-2.355-1.162-2.72-1.294-.365-.133-.631-.199-.897.199-.266.398-1.03 1.294-1.263 1.56-.232.266-.465.299-.863.1-.398-.199-1.681-.62-3.203-1.977-1.184-1.057-1.983-2.363-2.215-2.761-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.698.199-.232.266-.398.398-.664.133-.266.066-.498-.033-.697-.1-.199-.897-2.162-1.229-2.96-.324-.779-.653-.673-.897-.686l-.764-.013c-.266 0-.698.1-1.063.498-.365.398-1.395 1.362-1.395 3.322s1.428 3.854 1.627 4.12c.199.266 2.811 4.292 6.812 6.022.952.411 1.695.657 2.274.841.955.304 1.825.261 2.513.158.767-.114 2.355-.963 2.688-1.893.332-.93.332-1.727.232-1.893-.099-.166-.365-.266-.763-.465z" />
          </svg>
        </a>
      </div>
    );
  }

  // ── Original feedback button (all other pages) ──
  const modal = (
    <>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999999, padding: 20 }}>
        <div onClick={e => e.stopPropagation()} style={{ width: '90%', maxWidth: 500, background: '#fff', borderRadius: 16, maxHeight: '90vh', overflowY: 'auto', direction: dir, position: 'relative', zIndex: 1000000 }}>
          <h2 style={{ background: '#198754', color: '#fff', padding: '10px 16px', borderRadius: '16px 16px 0 0', fontSize: 15, fontWeight: 600, margin: 0, lineHeight: 1.3 }}>{t.title}</h2>
          <div style={{ padding: '12px 16px 14px' }}>
            <input type="email" style={inp} value={email} onChange={e => setEmail(e.target.value)} placeholder={t.email} />
            <textarea style={{ ...inp, minHeight: 75 }} value={feedbackText} onChange={e => setFeedbackText(e.target.value)} placeholder={t.ph} />
            <div style={{ textAlign: 'center', marginBottom: 10 }}>
              <p style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: 4 }}>{t.rate}</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 4, direction: 'ltr', fontSize: '2.2rem', cursor: 'pointer', userSelect: 'none' }}>
                {[1, 2, 3, 4, 5].map(star => <span key={star} onClick={() => setRating(star)}>{star <= rating ? '⭐' : '☆'}</span>)}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={() => setOpen(false)} style={{ flex: 1, padding: '8px 16px', border: 0, borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', color: '#fff', background: '#0d6efd' }}>{t.cancel}</button>
              <button onClick={handleSubmit} disabled={!feedbackText.trim() || loading} style={{ flex: 1, padding: '8px 16px', border: 0, borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', color: '#fff', background: loading || !feedbackText.trim() ? '#ccc' : '#198754' }}>
                {loading ? <><span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid #fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite', marginRight: 8 }}></span>{t.sending}</> : t.send}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {!isMobile && (
        <div style={{ position: 'fixed', bottom: 80, left: 20, zIndex: 1300 }}>
          <button id="auto-feedback-btn" disabled={buttonLoading} onClick={handleOpen}
            style={{ background: '#198754', color: '#fff', border: 0, borderRadius: 50, padding: '10px 20px', fontSize: 16, cursor: buttonLoading ? 'not-allowed' : 'pointer', opacity: buttonLoading ? 0.7 : 1 }}>
            {buttonLoading ? t.load : t.btn}
          </button>
        </div>
      )}
      {isMobile && <button id="auto-feedback-btn" onClick={handleOpen} style={{ display: 'none' }} />}
      {open && modal}
    </>
  );
};

export default FeedbackButton;